import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { SharedService } from 'src/app/common/services/shared.service';
import { ProjectConstant } from './report-project-details.constants';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ReportsViewEnum } from 'src/app/reports/models/enums/reports.enum';
import { ReportService } from 'src/app/reports/services/report.service';
import { DisableAnchorCategories, projectMenuEnum } from './report-project-menu-enum';
import { ReportProjectDetailsService } from './report-project-details.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { layerConstant } from 'src/app/common/constants/layer-constant';
import moment from 'moment';

@Component({
  selector: 'app-report-project-details',
  templateUrl: './report-project-details.component.html',
  styleUrls: ['./report-project-details.component.scss']
})
export class ReportProjectDetailsComponent {

  @Input() projectInfo: any = {};
  @Input() propertyUid: any = '';
  // overViewMenu = ProjectConstant.overViewMenu;
  menuEnum = projectMenuEnum;
  currentScroll: any;
  activeTab: any = '';
  // full static list — always same order
  fullMenuList = [...ProjectConstant.overViewMenu];  
  selectedMunicipalParcelUid: string = '';
  // dynamic list to show on UI (filtered)
dataState: Record<string, boolean> = {};
visibleMenuList: any[] = [];

  currentLang: string = '';
  languageSub$: Subscription = new Subscription();

  currentReportView: number = ReportsViewEnum.mapView;
  currentReportView$: Subscription = new Subscription();

  isFirstTime = true;
  landParcelLoading: boolean = false;
  private destroy$ = new Subject<void>();

  landParceldata: any[] = [];
  landParcelCount: any;
  landParcelColumns = ProjectConstant.landParcelColumns;

  propertyHousesLoading: boolean = false;
  propertyHousesdata: any[] = [];
  propertyHousesCount: any;
  propertyHousesColumns = ProjectConstant.propertyHousesColumns;

  propertyOthersLoading: boolean = false;
  propertyOthersdata: any[] = [];
  propertyOthersCount: any;
  propertyOthersColumns = ProjectConstant.propertyOthersColumns;
  landPricesColumns = ProjectConstant.landPricesColumns;
  propertyPricesColumns = ProjectConstant.propertyPricesColumns;
  unitPricesColumns = ProjectConstant.projectUnitPricesColumns;

  residentialrentalLoading: boolean = false;
  residentialrentaldata: any[] = [];
  residentialrentalCount: any;
  residentialrentalColumns = ProjectConstant.residentialColumns;

  filteredResidentialRentalData: any[] = [];
  residentialPropertyTypes: any[] = [];
  selectedResidentialTypes: any[] = [];

  retailRentalLoading: boolean = false;
  retailRentaldata: any[] = [];
  retailRentalCount: any;
  retailRentalColumns = ProjectConstant.retailColumns;

  officeRentalLoading: boolean = false;
  officeRentaldata: any[] = [];
  officeRentalCount: any;
  officeRentalColumns = ProjectConstant.officeColumns;

  warehouseRentalLoading: boolean = false;
  warehouseRentaldata: any[] = [];
  warehouseRentalCount: any;
  warehouseRentalColumns = ProjectConstant.warehouseColumns;

  projectLandPriceDetailsLoading: boolean = false;
  projectLandPriceDetailsdata: any[] = [];
  projectLandPriceDetailsCount: any;
  projectLandPriceDetailsColumns = ProjectConstant.landPricesColumns;
  projectLandActualCount: number = 0;
  projectLandEstimatedCount: number = 0;
  projectLandAuctionCount: number = 0;


  projectPropertyPriceDetailsLoading: boolean = false;
  projectPropertyPriceDetailsdata: any[] = [];
  projectPropertyPriceDetailsCount: any;
  projectPropertyPriceDetailsColumns = ProjectConstant.propertyPricesColumns;
  projectPropertyPriceActualCount: number = 0;
  projectPropertyPriceEstimatedCount: number = 0;
  projectPropertyPriceAuctionCount: number = 0;

  projectUnitPriceDetailsLoading: boolean = false;
  projectUnitPriceDetailsdata: any[] = [];
  projectUnitPriceDetailsCount: any;
  projectUnitPriceDetailsColumns = ProjectConstant.projectUnitPricesColumns;
  projectUnitPriceDetailsActualCount: number = 0;
  projectUnitPriceDetailsEstimatedCount: number = 0;
  projectUnitPriceDetailsAuctionCount: number = 0;

  downloadLoading: any = {
    a: false,
    b: false,
    c: false,
    d: false,
    e: false,
    f: false,
    g: false,
    h: false,
    i: false,
    j: false
  };

  userInfo: any = 0;
  placeCode: string = '';
  CurrencyCode: string = '';
  tableName: any;
  projectUid: string = '';
  overviewMenuShow = true;
  projLandPriceAnalysisLoading: boolean = false;
  getLandPriceGraphData: any;
  landPriceChart: any;
  projPropertyPriceAnalysisLoading: boolean = false;
  getPropertyPriceGraphData: any;
  PropertyPriceChart: any;

  ReasidentialGraphDataisLoading: boolean = false;
  getReasidentialGraphData: any;
  ReasidentialGraphChart: any;

  RetailGraphDataisLoading: boolean = false;
  getRetailGraphData: any;
  RetailGraphChart: any;

  OfficeGraphDataisLoading: boolean = false;
  getOfficeGraphData: any;
  OfficeGraphChart: any;
  langName: any;

  getProjectApartmentGraphData: any;
  projectApartmentPriceAnalysisLoading: boolean = false;
  projectResidentialPriceAnalysisLoading: boolean = false;
  getProjectResidentialGraphData: any;
  isWarehouseReport: boolean=false;

  // propertyCategory!: string;
  // property_cat_subcat!: string;

  isFirstLoad = true;
  showApartAnalysisSection = false;

  chartSection = {
    chart1:false,
    chart2:false,
    chart3:false,
    chart4:false,
    chart5:false,
    chart6:false,
    chart7:false  
  }


  constructor(
    private sharedService: SharedService,
    public reportService: ReportService,
    private projectService: ReportProjectDetailsService,
    private alertService: AlertService,
    private translate: TranslateService,
    private decimalPipe: DecimalPipe,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.sharedService.language$.subscribe(lang => {
      this.langName = lang;
     
      this.chartSection = {
        chart1:false,
        chart2:false,
        chart3:false,
        chart4:false,
        chart5:false,
        chart6:false,
        chart7:false  
      }
      this.getLandPriceGraphData = null;
      this.getPropertyPriceGraphData = null;
      this.getProjectResidentialGraphData = null;
      this.getProjectApartmentGraphData = null;
      this.getReasidentialGraphData = null;
      this.getRetailGraphData = null;
      this.getOfficeGraphData = null;
      
      if (lang && !this.isFirstTime) {
        this.getReports(true);
      }
    })
    //If secound time param change(Apply Filter) so project detail page hide
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (!this.isFirstTime) {
        this.reportService.isProjectDetailOpen.set(false);
      }
    })

    // this.propertyCategory = this.activatedRoute.snapshot.queryParams['property_category'];
    // this.property_cat_subcat = this.activatedRoute.snapshot.queryParams['property_cat_subcat'];

  }
  /** reusable helper to update visibility */
handleMenuVisibility(menuName: string, hasData: boolean) {
  const prev = this.dataState[menuName];
  this.dataState[menuName] = hasData;

  // Only update visible list if there’s an actual change
  if (prev !== hasData) {
    this.updateVisibleMenus();
  }
}


  /** filter visible menus */
updateVisibleMenus() {
  this.visibleMenuList = this.fullMenuList.filter(menu =>
    this.dataState[String(menu.name)] === true ||
    String(menu.name) === String(projectMenuEnum.overview)
  );
}



  ngOnInit(): void {
    this.fullMenuList.forEach(menu => {
        this.dataState[String(menu.name)] = false;
      });
    if (this.sharedService.priceCalculation$() === this.sharedService.priceYearly) {
      this.residentialrentalColumns[3]['columnName'] ='reports.avg_annual_rent_rate'
    }

    this.setLang();
    this.getReportView();
    this.isFirstTime = false;
    this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    this.CurrencyCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode);
    this.reportService.detailPageState$.next(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.overViewMenu = ProjectConstant.overViewMenu;
    // this.handleMenuVisibility(String(projectMenuEnum.overview), true);

  const category = this.activatedRoute.snapshot.queryParams['property_category'] || this.activatedRoute.snapshot.queryParams['property_cat_subcat'];
  this.isWarehouseReport = DisableAnchorCategories.includes(category);

  // Assign fresh copies (so constants aren’t mutated)
  this.projectUnitPriceDetailsColumns = [...ProjectConstant.projectUnitPricesColumns];
  this.projectPropertyPriceDetailsColumns = [...ProjectConstant.propertyPricesColumns];

    if (changes['projectInfo']?.currentValue?.proj_uid) {
      this.projectUid = changes['projectInfo']?.currentValue?.proj_uid;
      this.scrollPoint(String(this.menuEnum.overview));
      this.projectService.projDetailHouses.pageNumber = 0;
      this.getReports();
    }
    if (!changes['projectInfo']?.currentValue?.proj_uid && changes['propertyUid']?.currentValue) {
      this.projectUid = this.propertyUid;
      this.scrollPoint(String(this.menuEnum.overview));
      this.projectService.projDetailHouses.pageNumber = 0;
      this.getReports();
    }
  }
 

  getReports(langChange = false) {
    this.checkGraphData();
    this.handleMenuVisibility(String(projectMenuEnum.overview), true);
    this.getLandParcel();
    this.getPropertyHouses(langChange);
    this.getPropertyOthers();
    this.getResidentialRental(langChange);
    this.getRetailRental(langChange);
    this.getOfficeRental(langChange);
    this.getWarehouseRental(langChange);
    this.getLandPriceDetails(langChange);
    this.getPropertyPriceDetails(langChange);
    this.getUnitPRiceDetails(langChange);
    this.getLandPriceAnalysisDetails();
    this.getPropertyPriceAnalysisDetails();
    this.getResidentialRentalAnalysis();
    this.getRetailRentalAnalysis();
    this.getOfficeRentalAnalysis();
    this.getProjectApartmentPriceAnalysis();
    this.getProjectResidentialBuildingPriceAnalysis()
    
  }

  /**
   * Land Parcel Table API
   */
  getLandParcel() {
    this.landParcelLoading = true;
    this.projectService.getLandParcel(this.projectService.projDetailLandParcel, this.projectUid)
      .pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: (res: any) => {
            this.landParcelLoading = false;
            if (res.status === 200) {
              this.landParceldata = res.data.map((item: any) => ({
                ...item,
                matched: !!(this.projectInfo?.property_category?.includes(layerConstant.industry_workshop_warehouse_cat) && !!this.projectInfo?.project_name && item?.parcel_uid === this.projectInfo?.parcel_uid)
              }));

              this.landParceldata = this.reportService.setTableDataSource(this.landParceldata);
              if (this.projectService.projDetailLandParcel.pageNumber == 0) {
              this.landParcelCount = res.count // this.decimalPipe.transform((res.count), '1.0-1')
               this.handleMenuVisibility(String(projectMenuEnum.landParcelTable),this.landParceldata.length > 0);
              }
            } else {
              this.landParceldata = [];
              this.landParcelCount = 0;
            }
          },
          error: (error: any) => {
            this.landParceldata = [];
            this.landParcelCount = 0;
            this.landParcelLoading = false;
            this.handleMenuVisibility(String(projectMenuEnum.landParcelTable),false);

          }

        }
      )
  }


  /**
   * Property Details - Houses API
   */
  getPropertyHouses(langChange = false) {
    this.propertyHousesLoading = true;
    this.projectService.getPropertyHouses(this.projectService.projDetailHouses, this.projectUid)
      .pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: (res: any) => {
            this.propertyHousesLoading = false;
            if (res.status === 200) {
              this.propertyHousesdata = res.data;
              if (this.projectService.projDetailHouses.pageNumber == 0) {
                this.propertyHousesCount = res.count //this.decimalPipe.transform((res.count), '1.0-1');
                 this.handleMenuVisibility(String(projectMenuEnum.propertyDetailsHouses),this.propertyHousesdata.length > 0);
                if (!langChange) {
                  this.overviewMenuShow = false;
                  setTimeout(() => this.overviewMenuShow = true);
                }
              }
            } else {
              this.propertyHousesdata = [];
              this.propertyHousesCount = 0;
              this.handleMenuVisibility(String(projectMenuEnum.propertyDetailsHouses),false);
              // this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.propertyDetailsHouses);// remove title from the top
              if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
            }
          },
          error: (error: any) => {
            this.propertyHousesdata = [];
            this.propertyHousesCount = 0;
            this.propertyHousesLoading = false;
            this.handleMenuVisibility(String(projectMenuEnum.propertyDetailsHouses),false);
            // this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.propertyDetailsHouses); // remove title from the top
            if (!langChange) {
              this.overviewMenuShow = false;
              setTimeout(() => this.overviewMenuShow = true);
            }
          }

        }
      )
  }

  /**
   * Property Details - Others API
   */
  getPropertyOthers() {
    this.propertyOthersLoading = true;
    this.projectService.getPropertyOthers(this.projectService.projDetailOthers, this.projectUid)
      .pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: (res: any) => {
            this.propertyOthersLoading = false;
            if (res.status === 200) {
              this.propertyOthersdata = res.data;
              if (this.projectService.projDetailOthers.pageNumber == 0) {
                this.propertyOthersCount = res.count; //this.decimalPipe.transform((res.count), '1.0-1');
                 this.handleMenuVisibility( String (projectMenuEnum.propertyDetailsOthers),this.propertyOthersdata.length > 0);
              }
            } else {
              this.propertyOthersdata = [];
              this.propertyOthersCount = 0;
              this.handleMenuVisibility(String(projectMenuEnum.propertyDetailsOthers),false);
              //  this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.propertyDetailsOthers);
            }
          },
          error: (error: any) => {
            this.propertyOthersdata = [];
            this.propertyOthersCount = 0;
            this.propertyOthersLoading = false;
             this.handleMenuVisibility(String(projectMenuEnum.propertyDetailsOthers),false);
            //  this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.propertyDetailsOthers);
          }

        }
      )
  }
  /**
     * Property Details - Reasidential API
     */
getResidentialRental(langChange = false) {
  const gradeOrder = ['A+', 'A', 'B', 'C', 'Undefined'];
  this.residentialrentalLoading = true;

  this.projectService.getResidentialRental(this.projectService.projDetailOthers, this.projectUid)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (res: any) => {
        this.residentialrentalLoading = false;

        if (res.status === 200) {
          // ✅ Map se data format karo (UI ke liye)
          res.data.map((el: any) => {
            Object.keys(el).map((key: any) => {
              if (key !== 'type') {
                // Comma + decimal formatted string bana ke UI me dikhaenge
                el[key] = this.reportService.rangeToNumberFor(el[key]);
              }
            });
            // ✅ Property grade key set for dropdown
            el.property_grade_key = el.property_grade || 'undefined';
          });

          // ✅ Data source set
          this.residentialrentaldata = this.reportService.setTableDataSource(res.data);

          // ✅ Dropdown list sorted order me (A+, A, B, C, Undefined)
          this.residentialPropertyTypes = Array.from(
            new Set(this.residentialrentaldata.map((item: any) => item.property_grade_key))
          )
          .filter(t => t && t.trim() !== '')
          .sort((a, b) => gradeOrder.indexOf(a) - gradeOrder.indexOf(b));

          // ✅ Select all types by default
          this.selectedResidentialTypes = [...this.residentialPropertyTypes];
          this.applyResidentialTypeFilter();

          // ✅ Count & menu refresh
          if (this.projectService.projDetailOthers.pageNumber === 0) {
            this.residentialrentalCount = res.count;
            this.handleMenuVisibility( String (projectMenuEnum.ResidentialRental),this.residentialrentaldata.length > 0);
            if (!langChange) {
              this.overviewMenuShow = false;
              setTimeout(() => this.overviewMenuShow = true);
            }
          }
        } else {
          this.filteredResidentialRentalData = [];
          this.residentialrentalCount = 0;
           this.handleMenuVisibility(String(projectMenuEnum.ResidentialRental),false);

          // this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.ResidentialRental);
          if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
        }
       
      },
      error: () => {
        this.filteredResidentialRentalData = [];
        this.residentialrentalCount = 0;
        this.residentialrentalLoading = false;
         this.handleMenuVisibility(String(projectMenuEnum.ResidentialRental),false);
        // this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.ResidentialRental);
        if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
      }
      
    });
}


  applyResidentialTypeFilter() {
    this.filteredResidentialRentalData = this.residentialrentaldata.filter((item: any) =>
      this.selectedResidentialTypes.includes(item.property_grade_key)
    );
  }

  toggleResidentialType(event: any, property_grade_key: string) {
    if (event.checked) {
      if (!this.selectedResidentialTypes.includes(property_grade_key)) {
        this.selectedResidentialTypes.push(property_grade_key);
      }
    } else {
      // Prevent deselecting the last remaining option
      if (this.selectedResidentialTypes.length === 1) {
        event.source.checked = true; // revert checkbox visually
        return;
      }
      this.selectedResidentialTypes = this.selectedResidentialTypes.filter(t => t !== property_grade_key);
    }

    this.applyResidentialTypeFilter();
  }

  //Property Details - RetailRental API
  getRetailRental(langChange = false) {
    this.retailRentalLoading = true;
    this.projectService.getRetailRental(this.projectService.projDetailOthers, this.projectUid)
      .pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: (res: any) => {
            this.retailRentalLoading = false;
            if (res.status === 200) {

              res.data.map((el: any) => {
                Object.keys(el).map((e: any) => {
                  if ('unit_size' != (e)) {
                    el[e] = this.reportService.rangeToNumberFor(el[e]);
                  }
                  if (el.details && el.details.length > 0) {
                    el.details.map((detail: any) => {
                      Object.keys(detail).map((key: any) => {
                        if ('unit_size' != (key)) {
                          detail[key] = this.reportService.rangeToNumberFor(detail[key]);
                        }
                      })
                    })
                  }
                })
              })
              this.retailRentaldata = res.data;

              this.retailRentaldata = this.reportService.setTableDataSource(this.retailRentaldata);

              if (this.projectService.projDetailOthers.pageNumber == 0) {
                this.retailRentalCount = res.count; //this.decimalPipe.transform((res.count), '1.0-1');
                this.handleMenuVisibility( String (projectMenuEnum.RetailRental),this.retailRentaldata.length > 0);
               
                if (!langChange) {
                  this.overviewMenuShow = false;
                  setTimeout(() => this.overviewMenuShow = true);
                }
              }
            } else {
              this.retailRentaldata = [];
              this.retailRentalCount = 0;
                 this.handleMenuVisibility(String(projectMenuEnum.RetailRental),false);
              // this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.RetailRental);
              if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
            }
          },
          error: (error: any) => {
            this.retailRentaldata = [];
            this.retailRentalCount = 0;
            this.retailRentalLoading = false;
             this.handleMenuVisibility(String(projectMenuEnum.RetailRental),false);
            // this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.RetailRental);
            if (!langChange) {
              this.overviewMenuShow = false;
              setTimeout(() => this.overviewMenuShow = true);
            }
          }
        });
  }
  //Property Details - OfficeRental API
  getOfficeRental(langChange = false) {
    this.officeRentalLoading = true;
    this.projectService.getOfficeRental(this.projectService.projDetailOthers, this.projectUid)
      .pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: (res: any) => {
            this.officeRentalLoading = false;
            if (res.status === 200) {
              res.data.map((el: any) => {
                Object.keys(el).map((e: any) => {
                  if (e !== 'unit_size' && '' != (e)) {
                    el[e] = this.reportService.rangeToNumberFor(el[e]);
                  }
                  if (el.details && el.details.length > 0) {
                    el.details.map((detail: any) => {
                      Object.keys(detail).map((key: any) => {
                        if ('unit_size' != (key)) {
                          detail[key] = this.reportService.rangeToNumberFor(detail[key]);
                        }
                      })
                    })
                  }
                })
              })
              this.officeRentaldata = this.reportService.setTableDataSource(res.data);

              if (this.projectService.projDetailOthers.pageNumber == 0) {
                this.officeRentalCount = res.count; //this.decimalPipe.transform((res.count), '1.0-1');
                  this.handleMenuVisibility( String (projectMenuEnum.OfficeRental),this.officeRentaldata.length > 0);
                if (!langChange) {
                  this.overviewMenuShow = false;
                  setTimeout(() => this.overviewMenuShow = true);
                }
              }
            } else {
              this.officeRentaldata = [];
              this.officeRentalCount = 0;
               this.handleMenuVisibility(String(projectMenuEnum.OfficeRental),false);
              // this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.OfficeRental);
              if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
            }
          },
          error: (error: any) => {
            this.officeRentaldata = [];
            this.officeRentalCount = 0;
            this.officeRentalLoading = false;
            this.handleMenuVisibility(String(projectMenuEnum.OfficeRental),false);
            // this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.OfficeRental);
            if (!langChange) {
              this.overviewMenuShow = false;
              setTimeout(() => this.overviewMenuShow = true);
            }
          }
        });
  }
  //Property Details - WarehouseRental API
  getWarehouseRental(langChange = false) {
    this.warehouseRentalLoading = true;
    this.projectService.getWarehouseRental(this.projectService.projDetailOthers, this.projectUid)
      .pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: (res: any) => {
            this.warehouseRentalLoading = false;
            if (res.status === 200) {
              res.data.map((el: any) => {
                Object.keys(el).map((e: any) => {
                  if ('unit_size' != (e)) {
                    el[e] = this.reportService.rangeToNumberFor(el[e]);
                  }
                  if (el.details && el.details.length > 0) {
                    el.details.map((detail: any) => {
                      Object.keys(detail).map((key: any) => {
                        if ('unit_size' != (key)) {
                          detail[key] = this.reportService.rangeToNumberFor(detail[key]);
                        }
                      })
                    })
                  }
                })
              })
              this.warehouseRentaldata = res.data;
              this.warehouseRentaldata = this.reportService.setTableDataSource(this.warehouseRentaldata);

              if (this.projectService.projDetailOthers.pageNumber == 0) {
                this.warehouseRentalCount = res.count; //this.decimalPipe.transform((res.count), '1.0-1');
                  this.handleMenuVisibility( String (projectMenuEnum.WarehouseRental),this.warehouseRentaldata.length > 0);
                if (!langChange) {
                  this.overviewMenuShow = false;
                  setTimeout(() => this.overviewMenuShow = true);
                }
              }
            } else {
              this.warehouseRentaldata = [];
              this.warehouseRentalCount = 0;
              this.handleMenuVisibility(String(projectMenuEnum.WarehouseRental),false);
              // this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.WarehouseRental);
              if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
            }
          },
          error: (error: any) => {
            this.warehouseRentaldata = [];
            this.warehouseRentalCount = 0;
            this.warehouseRentalLoading = false;
            // this.overViewMenu = this.overViewMenu.filter(e => e.name != projectMenuEnum.WarehouseRental);
              this.handleMenuVisibility(String(projectMenuEnum.WarehouseRental),false);
            if (!langChange) {
              this.overviewMenuShow = false;
              setTimeout(() => this.overviewMenuShow = true);
            }
          }
        });
  }



  // Residential Rental
  getResidentialRentalAnalysis(filter:any=null) {
    this.ReasidentialGraphDataisLoading = true;
    this.projectService.getResidentialRentalAnalysis(this.projectUid, filter).subscribe({
      next: (res: any) => {
        if(res.status == 200){
          this.getReasidentialGraphData = res.data;
          this.getReasidentialGraphData['dropdown_data'] = res.data?.unit_type;
        }else{
          this.getReasidentialGraphData = null;
        }
        this.ReasidentialGraphDataisLoading = false;
        if (this.isFirstLoad == false) {
          this.chartSection.chart5 = true;
        } else {
          this.chartSection.chart5 = this.getReasidentialGraphData?.quarterly_rates?.length > 0;
        }
      },
      error: () => {
        this.getReasidentialGraphData = null;
        this.ReasidentialGraphDataisLoading = false;
      }
    });
  }
// app-report-project-details.component.ts

onParcelSelected(parcelUid: string) {
  console.log('Selected Parcel UID for Municipal Regulations:', parcelUid);
  this.selectedMunicipalParcelUid = parcelUid;
}
  // Retail Rental
  getRetailRentalAnalysis(filter:any=null) {
    this.RetailGraphDataisLoading = true;
    this.projectService.getRetailRentalAnalysis(this.projectUid, filter).subscribe({
      next: (res: any) => {
        if(res.status === 200){
          let rawData = res.data;
          this.getRetailGraphData = {
              ...rawData,
              dropdown_data: (rawData?.unit_size ?? []).map((e: any) => ({
                name: e,
                label: { 1: e, 2: e }
              }))
            };
        }else{
           this.getRetailGraphData = null;
        }
         if (this.isFirstLoad == false) {
            this.chartSection.chart6 = true;
          } else {
            this.chartSection.chart6 = this.getRetailGraphData?.quarterly_rates?.length > 0;
          }
         
        this.RetailGraphDataisLoading = false;
      },
      error: () => {
        this.getRetailGraphData = null;
        this.RetailGraphDataisLoading = false;
      }
    });
  }

  // Office Rental
  getOfficeRentalAnalysis(filter:any=null) {
    this.OfficeGraphDataisLoading = true;
    this.projectService.getOfficeRentalAnalysis(this.projectUid, filter).subscribe({
      next: (res: any) => {
        this.OfficeGraphDataisLoading = false;
        if(res.status === 200){
          let rawData = res.data;
          this.getOfficeGraphData = {
              ...rawData,
              dropdown_data: (rawData?.unit_size ?? []).map((e: any) => ({
                name: e,
                label: { 1: e, 2: e }
              }))
            };
        }else{
          this.getOfficeGraphData = null
        }
         if (this.isFirstLoad == false) {
            this.chartSection.chart7 = true;
          } else {
            this.chartSection.chart7 = this.getOfficeGraphData?.quarterly_rates?.length > 0;
          }
       
      },
      error: () => {
        this.getOfficeGraphData = null;
        this.OfficeGraphDataisLoading = false;
      }
    });
  }




    getLandPriceDetails(langChange = false) {
      this.projectLandPriceDetailsLoading = true;
    this.projectService.getProjectLandPrices(this.projectService.projDetailLandPrices, this.projectUid)
      .pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: (res: any) => {
          this.projectLandPriceDetailsLoading = false;
        if (res.status === 200) {
        if (res.data) {
  const dataArr = Array.isArray(res.data) ? res.data : [res.data];

  dataArr.forEach((value: any) => {

    value['transaction_date'] = value.transaction_date
      ? moment.utc(value.transaction_date).local().format('DD MMM YYYY')
      : null;
    value['value'] = this.reportType(value);
    if (value?.source_type) {
      value['price_type'] =
        (value['price_type'] ?? '') + ` (${value.source_type})`;
    }
    if (value?.details) {
      const detailsArr = Array.isArray(value.details)
        ? value.details
        : [value.details];

      detailsArr.forEach((d: any) => {
        d['transaction_date'] = d.transaction_date
          ? moment.utc(d.transaction_date).local().format('DD MMM YYYY')
          : null;
        d['value'] = this.reportType(d);
        if (d?.source_type) {
          d['price_type'] =
            (d['price_type'] ?? '') + ` (${d.source_type})`;
        }
      });
    }
  });
}
          this.projectLandPriceDetailsdata =
            this.reportService.setTableDataSource(res.data);


              if (this.projectService.projDetailOthers.pageNumber == 0) {
                this.projectLandPriceDetailsCount = res.count; //this.decimalPipe.transform((res.count), '1.0-1');
                  this.handleMenuVisibility( String (projectMenuEnum.landPrices),this.projectLandPriceDetailsdata.length > 0);
                this.projectLandActualCount = res.actual_count;
                this.projectLandAuctionCount = res.auction_count;
                this.projectLandEstimatedCount = res.quote_count ||0;
                   if (!langChange) {
                  this.overviewMenuShow = false;
                  setTimeout(() => this.overviewMenuShow = true);
                }

              }
            } else {
              this.projectLandPriceDetailsdata = [];
              this.projectLandPriceDetailsCount = 0;
               this.projectLandActualCount = 0;
                this.projectLandAuctionCount = 0;
                this.projectLandEstimatedCount = 0;
                this.handleMenuVisibility(String(projectMenuEnum.landPrices),false);
                //  this.overViewMenu = this.overViewMenu.filter(e=> e.name != projectMenuEnum.landPrices);// remove title from the top
              if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
            }
          },
          error: (error: any) => {
            this.projectLandPriceDetailsdata = [];
            this.projectLandPriceDetailsCount = 0;
            this.projectLandActualCount = 0;
            this.projectLandAuctionCount = 0;
            this.projectLandEstimatedCount = 0;
            this.projectLandPriceDetailsLoading = false;
             this.handleMenuVisibility(String(projectMenuEnum.landPrices),false);
              // this.overViewMenu = this.overViewMenu.filter(e=> e.name != projectMenuEnum.landPrices);// remove title from the top
              if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
          }

        }
      )
  }

  getLandPriceAnalysisDetails(filter:any=null) {
    this.projLandPriceAnalysisLoading = true;
    this.projectService.getProjectLandPricesAnalysis(this.projectUid, filter).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            const rawData = res.data;
            this.getLandPriceGraphData = {
              ...rawData,
              dropdown_data: (rawData?.zoning ?? []).map((e: any) => ({
                name: e,
                label: { 1: e, 2: e }
              }))
            };
          } else {
            this.getLandPriceGraphData = null;
          }
          this.projLandPriceAnalysisLoading = false;
          if (this.isFirstLoad == false) {
            this.chartSection.chart1 = true;
          } else {
            this.chartSection.chart1 = this.getLandPriceGraphData?.quarterly_rates?.length > 0;
          }
          
        },
        error: (error: any) => {
          this.getLandPriceGraphData = null;
          this.projLandPriceAnalysisLoading = false;
        }
      }
    )
  }

  getPropertyPriceAnalysisDetails(filter:any=null) {
    this.projPropertyPriceAnalysisLoading = true;
    this.projectService.getProjectPropertyPricesAnalysis(this.projectUid, filter).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            const rawData = res.data;
            this.getPropertyPriceGraphData = {
              ...rawData,
              dropdown_data: (rawData?.zoning ?? []).map((e: any) => ({
                name: e,
                label: { 1: e, 2: e }
              }))
            };
          } else {
            this.getPropertyPriceGraphData = null;
          }
          if (this.isFirstLoad == false) {
            this.chartSection.chart2 = true;
          } else {
            this.chartSection.chart2 = this.getPropertyPriceGraphData?.quarterly_rates?.length > 0;
          }

          this.projPropertyPriceAnalysisLoading = false;
        },
        error: (error: any) => {
          this.getPropertyPriceGraphData = [];
          this.projPropertyPriceAnalysisLoading = false;
        }
      }
    )
  }

  getProjectApartmentPriceAnalysis(filter:any=null) {
    this.projectApartmentPriceAnalysisLoading = true;
    this.projectService.getProjectApartmentPriceAnalysis(this.projectUid, filter).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
              const rawData = res.data;
              this.getProjectApartmentGraphData = rawData;
              this.getProjectApartmentGraphData['dropdown_data'] = rawData?.unit_type;
          } else {
            this.getProjectApartmentGraphData = null;
          }
          if (this.isFirstLoad == false) {
            this.chartSection.chart4 = true;
          } else {
            this.chartSection.chart4 = this.getProjectApartmentGraphData?.quarterly_rates?.length > 0;
          }
          this.projectApartmentPriceAnalysisLoading = false;
        },
        error: (error: any) => {
          this.getProjectApartmentGraphData = null;
          this.projectApartmentPriceAnalysisLoading = false;
        }
      }
    )
  }
  getProjectResidentialBuildingPriceAnalysis(filter:any=null) {
    this.projectResidentialPriceAnalysisLoading = true;
    this.projectService.getProjectResidentialBuildingPriceAnalysis(this.projectUid, filter).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
            const rawData = res.data;
            this.getProjectResidentialGraphData = {
              ...rawData,
              dropdown_data: (rawData?.zoning ?? []).map((e: any) => ({
                name: e,
                label: { 1: e, 2: e }
              }))
            };
          } else {
            this.getProjectResidentialGraphData = null;
          }
          if (this.isFirstLoad == false) {
            this.chartSection.chart3 = true;
          } else {
            this.chartSection.chart3 = this.getProjectResidentialGraphData?.quarterly_rates?.length > 0;
          }
          this.projectResidentialPriceAnalysisLoading = false;
        },
        error: (error: any) => {
          this.getProjectResidentialGraphData = null;
          this.projectResidentialPriceAnalysisLoading = false;
        }
      }
    )
  }
    getPropertyPriceDetails(langChange = false) {
     this.projectPropertyPriceDetailsLoading = true;
    this.projectService.getPropertyPrice(this.projectService.projDetailPropertyPrices, this.projectUid)
      .pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: (res: any) => {
           this.projectPropertyPriceDetailsLoading = false;
        if (res.status === 200) {
        if (res.data) {
         const dataArr = Array.isArray(res.data) ? res.data : [res.data];
         dataArr.forEach((value: any) => {
    value['transaction_date'] = value.transaction_date
      ? moment.utc(value.transaction_date).local().format('DD MMM YYYY')
      : null;
    value['value'] = this.reportType(value);
    if (value?.source_type) {
      value['price_type'] =
      (value['price_type'] ?? '') + ` (${value.source_type})`;
    }
    if (value?.details) {
      const detailsArr = Array.isArray(value.details)
        ? value.details
        : [value.details];

      detailsArr.forEach((d: any) => {
        // ✅ format transaction_date (child)
        d['transaction_date'] = d.transaction_date
          ? moment.utc(d.transaction_date).local().format('DD MMM YYYY')
          : null;

        // ✅ assign formatted value (child)
        d['value'] = this.reportType(d);

        // ✅ concat price_type with source_type (child)
        if (d?.source_type) {
          d['price_type'] =
            (d['price_type'] ?? '') + ` (${d.source_type})`;
        }
      });
    }
  });
          }

              this.projectPropertyPriceDetailsdata =  this.reportService.setTableDataSource(res.data)

              if (this.projectService.projDetailOthers.pageNumber == 0) {
                this.projectPropertyPriceDetailsCount = res.count; //this.decimalPipe.transform((res.count), '1.0-1');
                  this.handleMenuVisibility( String (projectMenuEnum.propertyPrices),this.projectPropertyPriceDetailsdata.length > 0);
                this.projectPropertyPriceActualCount = res.actual_count;
                this.projectPropertyPriceEstimatedCount  = res.quote_count;
                this.projectPropertyPriceAuctionCount = res.auction_count || 0 ;
                   if (!langChange) {
                  this.overviewMenuShow = false;
                  setTimeout(() => this.overviewMenuShow = true);
                }
              }
            } else {
              this.projectPropertyPriceDetailsdata = [];
              this.projectPropertyPriceDetailsCount = 0;
              this.projectPropertyPriceActualCount = 0;
              this.projectPropertyPriceEstimatedCount = 0;
              this.projectPropertyPriceAuctionCount = 0;
               this.handleMenuVisibility(String(projectMenuEnum.propertyPrices),false);
              // this.overViewMenu = this.overViewMenu.filter(e=> e.name != projectMenuEnum.propertyPrices);// remove title from the top
              if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
            }
          },
          error: (error: any) => {
            this.projectPropertyPriceDetailsdata = [];
            this.projectPropertyPriceDetailsCount = 0;
            this.projectPropertyPriceActualCount = 0;
            this.projectPropertyPriceEstimatedCount = 0;
            this.projectPropertyPriceAuctionCount = 0;
            this.projectPropertyPriceDetailsLoading = false;
              this.handleMenuVisibility(String(projectMenuEnum.propertyPrices),false);
            //  this.overViewMenu = this.overViewMenu.filter(e=> e.name != projectMenuEnum.propertyPrices);// remove title from the top
              if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
          }

        }
      )
  }

    getUnitPRiceDetails(langChange = false) {
    this.projectUnitPriceDetailsLoading = true;
    this.projectService.getProjectUnitPrice(this.projectService.projDetailOthers, this.projectUid)
      .pipe(takeUntil(this.destroy$)).subscribe(
        {
          next: (res: any) => {
            this.projectUnitPriceDetailsLoading = false;
        if (res.status === 200) {
           if (res.data) {
  const dataArr = Array.isArray(res.data) ? res.data : [res.data];
  dataArr.forEach((value: any) => {
    // ✅ format transaction_date (parent)
    value['transaction_date'] = value.transaction_date
      ? moment.utc(value.transaction_date).local().format('DD MMM YYYY')
      : null;

    // ✅ assign formatted value (parent)
    value['value'] = this.reportType(value);

    // ✅ concat price_type with source_type (parent)
    if (value?.source_type) {
      value['price_type'] =
        (value['price_type'] ?? '') + ` (${value.source_type})`;
    }

    // ✅ handle details if present
    if (value?.details) {
      const detailsArr = Array.isArray(value.details)
        ? value.details
        : [value.details];

      detailsArr.forEach((d: any) => {
        // ✅ format transaction_date (child)
        d['transaction_date'] = d.transaction_date
          ? moment.utc(d.transaction_date).local().format('DD MMM YYYY')
          : null;

        // ✅ assign formatted value (child)
        d['value'] = this.reportType(d);

        // ✅ concat price_type with source_type (child)
        if (d?.source_type) {
          d['price_type'] =
            (d['price_type'] ?? '') + ` (${d.source_type})`;
        }
      });
    }

            });
          }

              this.projectUnitPriceDetailsdata =  this.reportService.setTableDataSource(res.data)

              if (this.projectService.projDetailOthers.pageNumber == 0) {
                this.projectUnitPriceDetailsCount = res.count; //this.decimalPipe.transform((res.count), '1.0-1');
                  this.handleMenuVisibility( String (projectMenuEnum.unitPrices),this.projectUnitPriceDetailsdata.length > 0);
                this.projectUnitPriceDetailsActualCount = res.actual_count;
                this. projectUnitPriceDetailsEstimatedCount  = res.quote_count;
                this.projectUnitPriceDetailsAuctionCount = res.auction_count || 0 ;
                 if (!langChange) {
                  this.overviewMenuShow = false;
                  setTimeout(() => this.overviewMenuShow = true);
                }
              }
            } else {
              this.projectUnitPriceDetailsdata = [];
              this.projectUnitPriceDetailsCount = 0;
              this.projectUnitPriceDetailsActualCount = 0;
              this.projectUnitPriceDetailsEstimatedCount = 0;
              this.projectUnitPriceDetailsAuctionCount = 0;
              this.handleMenuVisibility(String(projectMenuEnum.unitPrices),false);
              //  this.overViewMenu = this.overViewMenu.filter(e=> e.name != projectMenuEnum.unitPrices);// remove title from the top
              if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
            }
          },
          error: (error: any) => {
            this.projectUnitPriceDetailsdata = [];
            this.projectUnitPriceDetailsCount = 0;
            this.projectUnitPriceDetailsActualCount = 0;
            this.projectUnitPriceDetailsEstimatedCount = 0;
            this.projectUnitPriceDetailsAuctionCount = 0;
            this.projectUnitPriceDetailsLoading = false;
            this.handleMenuVisibility(String(projectMenuEnum.unitPrices),false);
              //  this.overViewMenu = this.overViewMenu.filter(e=> e.name != projectMenuEnum.unitPrices);// remove title from the top
              if (!langChange) {
                this.overviewMenuShow = false;
                setTimeout(() => this.overviewMenuShow = true);
              }
          }

        }
      )
  }


  reportType(value: any): string {
    let recordType = `<div class="reportType-value">${value.value ? this.reportService.numFormat(value.value): ''}</div>`;
    if (value?.prop_type_govt && value?.prop_type_estater && value?.prop_type_govt !== value?.prop_type_estater) {
      recordType += `<div class="reportType-land"><del>${this.translate.instant(value?.prop_type_govt)}</del><span class='reportType'>*${this.translate.instant(value?.prop_type_estater)}</span></div>`;
    } else if (value?.prop_type_govt) {
      recordType += `<div  class="reportType-land">${this.translate.instant(value?.prop_type_govt)}</div>`;
    } else if (value?.prop_type_estater) {
      recordType += `<div  class="reportType-land">${this.translate.instant(value?.prop_type_estater)}</div>`;
    }
    return recordType;
  }
  setLang(): void {
    this.languageSub$ = this.sharedService.language$.subscribe(lang => {
      this.currentLang = lang;
      // this.menuChangeValue(ProjectConstant.overViewMenu[0])
    })
  }

  getReportView() {
    this.currentReportView$ = this.reportService.reportView$.subscribe((view: number) => {
      this.currentReportView = view;
    });
  }

  backToTransaction() {
    this.reportService.isDetailPageOpen = false;
    this.reportService.isProjectDetailOpen.set(false);
    this.reportService.transactionPropertyDetails.next(false);
    this.reportService.detailPageState$.next(false);
  }

  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    this.activeTab = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }

  scrollPoint(menu: string) {
    this.sharedService.scrollMenu(menu);
  }

  onPageEvent(e: any, report: string) {
    if (report === 'landParcel') {
      if (e.previousPageIndex !== e.pageIndex) {
        this.projectService.projDetailLandParcel.pageNumber = (e.pageSize * e.pageIndex);
      }
      this.getLandParcel();
    } else if (report === 'propertyHouses') {
      if (e.previousPageIndex !== e.pageIndex) {
        this.projectService.projDetailHouses.pageNumber = (e.pageSize * e.pageIndex);
      }
      this.getPropertyHouses();
    } else if (report === 'propertyOthers') {
      if (e.previousPageIndex !== e.pageIndex) {
        this.projectService.projDetailOthers.pageNumber = (e.pageSize * e.pageIndex);
      }
      this.getPropertyOthers();
    }
    else if (report === 'projLandPrice') {
      if (e.previousPageIndex !== e.pageIndex) {
        this.projectService.projDetailLandPrices.pageNumber = (e.pageSize * e.pageIndex);
      }
      this.getLandPriceDetails()
    }
    else if (report === 'projectPropertyPrices') {
      if (e.previousPageIndex !== e.pageIndex) {
        this.projectService.projDetailPropertyPrices.pageNumber = (e.pageSize * e.pageIndex);
      }
      this.getPropertyPriceDetails()
    }
    else if (report === 'projectUnitPrices') {
      if (e.previousPageIndex !== e.pageIndex) {
        this.projectService.projDetailUnitPrices.pageNumber = (e.pageSize * e.pageIndex);
      }
      this.getUnitPRiceDetails()
    }
  }
  sortData(event: any, report: string) {
    let sort = {
      column: event.active,
      order: event.direction
    }
    if (report === 'landParcel') {
      this.projectService.projDetailLandParcel.pageNumber = 0;
      this.projectService.projDetailLandParcel.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');;
      this.getLandParcel();
    } else if (report === 'propertyHouses') {
      this.projectService.projDetailHouses.pageNumber = 0;
      this.projectService.projDetailHouses.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');;
      this.getPropertyHouses();
    } else if (report === 'propertyOthers') {
      this.projectService.projDetailOthers.pageNumber = 0;
      this.projectService.projDetailOthers.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');;
      this.getPropertyOthers();
    } else if (report === 'projLandPrice') {
      this.projectService.projDetailLandPrices.pageNumber = 0;
      this.projectService.projDetailLandPrices.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');;
      this.getLandPriceDetails();
    } else if (report === 'residentialRental') {  // ✅ NEW CASE
      this.projectService.projDetailOthers.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
      this.getResidentialRental();  // ✅ same function reuse
    }
    else if (report === 'projectPropertyPrices') {
      this.projectService.projDetailPropertyPrices.pageNumber = 0;
      this.projectService.projDetailPropertyPrices.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');;
      this.getPropertyPriceDetails();
    }
    else if (report === 'projectUnitPrices') {
      this.projectService.projDetailUnitPrices.pageNumber = 0;
      this.projectService.projDetailUnitPrices.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');;
      this.getUnitPRiceDetails();
    }
  }
  downloadExcel(event: any, type: string, key: any) {
    this.downloadReport(type, 'project_details', key);
  }
  downloadReport(type: string, module_name: string, key: any) {
    this.downloadLoading[key] = true;
    this.projectService.downloadProjectDetail(type, this.userInfo?.user_id, this.projectUid).subscribe(
      {
        next: (res: any) => {
          this.downloadLoading[key] = false;
          if (res.status === 200) {
            const downloadUrl = `${this.projectService.downloadExcelUrl()}?file_name=${res.data}&city_code=${this.placeCode.toLowerCase()}&module_name=${module_name}`;
            this.sharedService.downloadExcelUrl(downloadUrl);
            this.alertService.success(this.translate.instant('reports.downloadRequestSubmitted'));
          } else {
            this.alertService.warn(res.message)
          }
        },
        error: (error: any) => {
          this.downloadLoading[key] = false;
        }
      }
    )
  }
  lastClickedTable(event: Event, table: any) {
    this.tableName = table
  }

  checkGraphData() {
    // Example check for data existence
    this.chartSection.chart1 = !!this.getLandPriceGraphData && Object.keys(this.getLandPriceGraphData).length > 0;
    this.chartSection.chart2 = !!this.getPropertyPriceGraphData && Object.keys(this.getPropertyPriceGraphData).length > 0;
    this.chartSection.chart3 = !!this.getProjectResidentialGraphData && Object.keys(this.getProjectResidentialGraphData).length > 0;
    this.chartSection.chart4 = !!this.getProjectApartmentGraphData && Object.keys(this.getProjectApartmentGraphData).length > 0;
    this.chartSection.chart5 = !!this.getReasidentialGraphData && Object.keys(this.getReasidentialGraphData).length > 0;
    this.chartSection.chart6 = !!this.getRetailGraphData && Object.keys(this.getRetailGraphData).length > 0;
    this.chartSection.chart7 = !!this.getOfficeGraphData && Object.keys(this.getOfficeGraphData).length > 0;
  }


  chatSelectionChange(event:any,type:string){
    this.isFirstLoad = false;
    if(type == 'chart1'){
      this.getLandPriceAnalysisDetails(event)
    }else if(type == 'chart2'){
      this.getPropertyPriceAnalysisDetails(event);
    }else if(type == 'chart3'){
      this.getProjectResidentialBuildingPriceAnalysis(event);
    }else if(type == 'chart4'){
     this.getProjectApartmentPriceAnalysis(event)
    }else if(type == 'chart5'){
      this.getResidentialRentalAnalysis(event);
    }else if(type == 'chart6'){
      this.getRetailRentalAnalysis(event);
    }else if(type == 'chart7'){
      this.getOfficeRentalAnalysis(event);
    }
    
  }

  ngOnDestroy() {
    this.destroy$.next(); // Emit signal to unsubscribe
    this.destroy$.complete(); // Clean up the Subject
  }
}
